import { render, staticRenderFns } from "./Admin_center.vue?vue&type=template&id=86137386"
import script from "./Admin_center.vue?vue&type=script&lang=js"
export * from "./Admin_center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports